import { useCallback, useState } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import type { SchedulingRule } from 'repository/schedule/@types/SchedulingRuleModel';

export const useSchedulingRuleTableState = () => {
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState<SchedulingRule[]>([]);
    const [selected, setSelected] = useState<GridRowSelectionModel>([]);

    const cleanSelected = useCallback(() => {
        setSelectedRow([]);
        setSelected([]);
    }, []);

    return {
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
    };
};
